import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _Map from "@babel/runtime-corejs3/core-js/map";
import { useInstance, createRef, findDomFromVNode, onBeforeMount, nextTick } from 'intact-vue-next';
import { useState, watchState } from '../../hooks/useState';
import { tag as tagStyles } from './styles';
import { getLeft, getRight } from '../../styles/utils';
import { useReceive } from '../../hooks/useReceive';
import { useResizeObserver } from '../../hooks/useResizeObserver';
export function useNowrap(originVNodes) {
  var instance = useInstance();
  var containerRef = createRef();
  var children = useState([]);
  var hiddenChildren = useState([]);
  var estimateMoreElementWidth = useEstimateMoreElementWidth();
  var offsetMap = useChildrenOffset(originVNodes);
  watchState(originVNodes, function (v) {
    children.set(v);
    nextTick(refresh);
  });
  // instance.watch('children', refresh, { presented: true })
  useResizeObserver(containerRef, refresh);
  function refresh() {
    if (!instance.get('nowrap') || instance.$unmounted) return;
    var container = containerRef.value;
    var containerWidth = container.offsetWidth;
    var vNodes = [];
    var _originVNodes = originVNodes.value;
    var length = _originVNodes.length;
    if (_originVNodes.length > 1) {
      _originVNodes.forEach(function (vNode, index) {
        var offset = offsetMap.get(vNode);
        // estimate the "more" element's with for performance
        var width = estimateMoreElementWidth(length - index - 1);
        if (offset + width <= containerWidth) {
          vNodes.push(vNode);
        }
      });
    } else {
      vNodes.push.apply(vNodes, _originVNodes);
    }
    /**
     * refresh function will be called in ResizeObserver,
     * state changed will cause container's width to change,
     * and a error will throw (ResizeObserver loop completed with undelivered notifications)
     * so we call setState in requestAnimationFrame
     */
    requestAnimationFrame(function () {
      hiddenChildren.set(_sliceInstanceProperty(_originVNodes).call(_originVNodes, vNodes.length));
      children.set(vNodes);
    });
  }
  return {
    containerRef: containerRef,
    children: children,
    hiddenChildren: hiddenChildren
  };
}
function useChildrenOffset(vNodes) {
  var instance = useInstance();
  var map = new _Map();
  // instance.watch('children', updateMap, { presented: true })
  watchState(vNodes, function () {
    return nextTick(updateMap);
  });
  function updateMap() {
    map.clear();
    if (!instance.get('nowrap')) return;
    vNodes.value.forEach(function (vNode) {
      var dom = findDomFromVNode(vNode, true);
      if (!dom || dom.nodeType !== 1) return;
      var offsetLeft = dom.offsetLeft,
        offsetWidth = dom.offsetWidth;
      map.set(vNode, offsetLeft + offsetWidth);
    });
  }
  return map;
}
function useEstimateMoreElementWidth() {
  var instance = useInstance();
  var widthPerChar = 7.2;
  var cacheWidth = 0;
  onBeforeMount(cache);
  useReceive(['size', 'border'], cache, true);
  function cache() {
    var _instance$get = instance.get(),
      size = _instance$get.size,
      border = _instance$get.border;
    cacheWidth = parseInt(tagStyles.tags.gap) + widthPerChar /* the "+" mark */;
    if (border !== 'none') {
      cacheWidth += 2;
    }
    var padding = size === 'default' ? tagStyles.padding : tagStyles[size].padding;
    cacheWidth += parseInt(getLeft(padding)) + parseInt(getRight(padding));
  }
  return function (count) {
    return Math.round(count.toString().length * widthPerChar + cacheWidth);
  };
}